<!--Mobile Search Filter Category's separate view on clicking see more - mobile device -->
<template>
  <div class="search-filter-category-page">
    <!-- START : Search Filter Category Header -->
    <WCMobileSubpageHeader :title="heading" :customClick="true" @customClickEvent="onGoBackClick" />
    <!-- END : Search Filter Category Header -->

    <!-- START: search box -->
    <WCSearchInput
      v-if="categoryValuesLength > itemsMaxLimit"
      :ariaLabel="$t('search')"
      :placeHolderText="$t('search')"
      @focusIn="hasFocus = true"
      @focusOut="hasFocus = false"
      :hasFocusInput="hasFocus"
      @onSearch="updateSearchValue"
      @updateValue="updateSearchValue"
      @onClear="updateSearchValue"
      :updatedSearchInput="searchInput"
      :value="searchInput"
    />
    <!-- END: search box -->

    <!-- START: Search Filter category items checkbox list -->
    <div class="container-fluid pt-3 pl-3 pr-3">
      <div v-for="value in filteredItems()" :key="value.name">
        <WCCheckbox
          :id="'search-filter-checkbox-' + category.key + '-' + value.key"
          class=" p-0 wc-filter-checkbox wc-filter-bar pb-2 pt-2"
          @update:modelValue="onChange(category, value, $event)"
          v-model="value.selected"
          :label="value.name"
        />
        <span class="float-right wc-filter-bar">{{ value.count }}</span>
        <hr class="row" />
      </div>
    </div>
    <!-- END: Search Filter category items checkbox list -->
  </div>
</template>

<script>
import WCCheckbox from '@/modules/forms/components/WCCheckbox/WCCheckbox.vue';
import WCMobileSubpageHeader from '@/components/WCMobileSubpageHeader/WCMobileSubpageHeader.vue';
import WCSearchInput from '@/components/WCSearchInput/WCSearchInput.vue';
import FacetFilterMixin from '@/modules/filters/mixins/FacetFilterMixin';
import { capitalizeFirstLetter } from '@/utils/formatters';
import { FILTER_ITEMS_MAX_LIMIT } from '@/constants/AppConstants';

export default {
  emits: ['onGoBackClick', 'categoryItemSearchInput'],
  name: 'MobileSearchFilterCategory',
  components: {
    WCMobileSubpageHeader,
    WCCheckbox,
    WCSearchInput,
  },
  mixins: [FacetFilterMixin],
  props: {
    categoryFilter: {
      type: Object,
    },
  },
  data() {
    return {
      category: this.categoryFilter,
      searchInput: '',
      hasFocus: false,
      itemsMaxLimit: FILTER_ITEMS_MAX_LIMIT,
    };
  },

  computed: {
    /**
     * To compute the category item values length
     */
    categoryValuesLength() {
      return this.category.values.length;
    },
    /**
     * To compute the header title value of see more popup
     */
    heading() {
      const capitalizedItemName = this.category.name
        .split(' ')
        .map(value => capitalizeFirstLetter(value))
        .join(' ');
      return capitalizedItemName;
    },
  },
  methods: {
    /**
     * Emit to MobileSearchFilter on clicking go back
     */
    onGoBackClick() {
      this.$emit('onGoBackClick');
    },
    /**
     * To update the search value on search,clear and update of search input
     */
    updateSearchValue(searchValue) {
      this.searchInput = searchValue;
      this.$emit('categoryItemSearchInput', this.searchInput, this.category.name);
      this.filteredItems();
    },
    /**
     * To update the list based on search in  see more page
     */
    filteredItems() {
      const self = this;
      if (self.searchInput) {
        return this.category.values.filter(function(item) {
          return item.name.toLowerCase().indexOf(self.searchInput.toLowerCase()) >= 0;
        });
      }
      return this.category.values;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/_tools.scss';
@import '~@/assets/styles/_settings.scss';

.search-filter-category-page {
  .wc-filter-checkbox {
    display: inline;
    margin-left: $margin-4;
  }

  .wc-filter-bar {
    font-weight: 500;
  }

  .wc-search-area {
    margin: 1rem;
  }
}
</style>
